import React, { useState } from "react";

import InputField from "../../../common/InputField";
import * as Yup from "yup";

import { Form, Formik } from "formik";
import { Typography, Box, Container } from "@mui/material";
import { PrimaryButton, SecondaryButton } from "../../../common/Buttons";
import { useTranslation } from "react-i18next";
const validate = (t) => {
  return Yup.object({
    FirstName: Yup.string()
      .required(t("required"))
      .max(50, t("max-50-characters"))
      .nullable(),
    Address: Yup.string().required(t("required")).nullable(),

    Email: Yup.string()
      .matches(
        // eslint-disable-next-line
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        t("Must-be-ValidEmail")
      )
      .nullable(),
    DOB: Yup.string().nullable(),

    PhoneNumber: Yup.number(t("must-be-number"))
      .min(0, t("must-be-positive"))
      .test(
        "len",
        t("less-than-15"),
        (val) => !val || (val && val.toString().length <= 15)
      )
      .nullable(),
  });
};

function GurdianStep2(props) {
  const { t } = useTranslation();
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const handleSubmit = async (formik) => {
    setButtonDisabled(true);
    let date = formik.DOB?.split("-");

    if (date[0].length > 4) {
    } else {
      let formData = new FormData();
      Object.keys(formik).forEach((key) =>
        formData.append(`${key}`, formik[key])
      );
    }
    setButtonDisabled(false);
  };
  const handleDateOfBirthKeyDown = (event) => {
    event.preventDefault(); 
  };
  return (
    <>
      <Container maxWidth="xs">
        <Box sx={{ mt: 5 }}>
          <Typography variant="p" paragraph align="left" color="color.black">
            {t("guardian-text-2")}
          </Typography>
          <Formik
            initialValues={{
              FirstName: "",
              Address: "",
              Email: "",
              DOB: new Date().toISOString().slice(0, 10),

              PhoneNumber: "",
            }}
            enableReinitialize
            validationSchema={validate(t)}
            onSubmit={handleSubmit}
          >
            {(formik) => (
              <Form>
                <InputField
                  fullWidth
                  variant="standard"
                  placeholder="John"
                  label={t("input-5")}
                  name="FirstName"
                  type="text"
                />

                <InputField
                  fullWidth
                  variant="standard"
                  label={t("input-2")}
                  name="DOB"
                  type="date"
                  onKeyDown={handleDateOfBirthKeyDown} 

                />
                {/* {dateError && (
                <p style={{ margin: 0, fontSize: "12px", color: "red" }}>
                  {dateError}
                </p>
              )} */}

                <InputField
                  variant="standard"
                  placeholder="Address "
                  label={t("input-12")}
                  name="Address"
                  type="text"
                />

                <InputField
                  fullWidth
                  variant="standard"
                  placeholder="demo@gmail.com"
                  label={t("input-3")}
                  name="Email"
                  type="email"
                />
                <InputField
                  fullWidth
                  variant="standard"
                  placeholder="2842394789"
                  label={t("input-4")}
                  name="PhoneNumber"
                  type="number"
                />

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    mt: 5,
                  }}
                >
                  <SecondaryButton
                    title={t("save-and-continue")}
                    bgColor="#E8D7E5"
                    borderRadius="14px"
                    padding="0.5rem 1.5rem"
                    marginLeft="20px"
                    border="none"
                    hoverBgColor="color.magentaLight1"
                    textTransform="initial"
                    onClick={handleSubmit(formik)}
                    disabled={buttonDisabled}
                  />

                  <Box component="div">
                    <Typography
                      variant="p"
                      color="color.magentaDark1"
                      marginLeft="10px"
                      fontSize="12px"
                      style={{ cursor: "pointer" }}
                      onClick={props.next}
                    >
                      {" "}
                      {t("skip-for-now")}
                    </Typography>
                  </Box>
                </Box>
              </Form>
            )}
          </Formik>
        </Box>
      </Container>
    </>
  );
}

export default GurdianStep2;
